module.exports = __webpack_public_path__ + "img/pages_highlights.ba69c906.webp";